import { ApiResponse } from '@collector/sportsapi-client-legacy'
import { SubParticipant } from '@collector/sportsapi-types'

import { HttpClient } from '../../httpClient.js'

export type SubParticipantsGetResponse = ApiResponse<{
  sub_participants: SubParticipant[]
}>

export async function get(
  httpClient: HttpClient,
  eventId: number,
): Promise<SubParticipantsGetResponse> {
  return httpClient.url(`/events/${eventId}/sub-participants`).get().json()
}
